export default function Skills() {
  return (
     <section id="skills" className="fade-in">
      <h2>Skills & Technologies</h2>
      <div className="terminal-cmd">
        <span className="cmd-prompt">kartik@portfolio</span><span className="cmd-path">:~/skills$</span> ls -la
      </div>
        
        <div className="skill-output">
          <div className="skill-group">
            <span className="skill-key">cloud:</span>
            <div className="skill-icons-row">
              <img src="https://skillicons.dev/icons?i=aws,docker,kubernetes,terraform&theme=dark" alt="Cloud" />
            </div>
          </div>
          
          <div className="skill-group">
            <span className="skill-key">devops:</span>
            <div className="skill-icons-row">
              <img src="https://skillicons.dev/icons?i=jenkins,githubactions,prometheus,grafana&theme=dark" alt="DevOps" />
            </div>
          </div>
          
          <div className="skill-group">
            <span className="skill-key">languages:</span>
            <div className="skill-icons-row">
              <img src="https://skillicons.dev/icons?i=python,java,bash&theme=dark" alt="Languages" />
            </div>
          </div>
          
          <div className="skill-group">
            <span className="skill-key">backend:</span>
            <div className="skill-icons-row">
              <img src="https://skillicons.dev/icons?i=fastapi,mysql,mongodb,nginx&theme=dark" alt="Backend" />
            </div>
          </div>
          
          <div className="skill-group">
            <span className="skill-key">tools:</span>
            <div className="skill-icons-row">
              <img src="https://skillicons.dev/icons?i=git,github,gitlab,linux,vim,vscode&theme=dark" alt="Tools" />
            </div>
          </div>
        </div>
        
        <div className="skill-line muted">
          <span className="skill-prompt">$</span>
          <span className="skill-cursor">_</span>
        </div>
        </section>
  );
}

